// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import { searchCancel, searchData, searchNumbers } from 'services/search';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    setSystemLoadingAction,
    SetSystemLoadingAction,
    ShowMessageAction,
    showMessageAction,
} from 'store/actions/errorsActions';
import {
    SetHighlightObjectAction,
    setHighlightObjectAction,
    SetLayoutAction,
    setLayoutAction,
    SetSearchControlsAction,
    setSearchControlsAction,
    SetSearchObjectAction,
    setSearchObjectAction,
    setSwitchAction,
    SetSwitchAction,
} from 'store/actions/layoutActions';
import { InterfaceVariablesType, Layout, OpenModal, PortType, RootState, SwitchType } from 'types';
import {
    ClearInterface,
    FavouritControlsInterface,
    GetFoundObjectNumbers,
    GetSearchObjectNumbers,
    MainControlsInterface,
    MapControlsInterface,
    ProfileControlsInterface,
    SearchInterface,
} from 'types/functions';
import { FilterObjectType } from 'types/search';
import { SummaryData, SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone, getId } from 'utils/formHandlers';
import {
    formatFilterObject,
    formatSavedFilter,
    formatSearchNumbers,
    formatTransits,
    replaceOptions,
} from 'utils/migrations';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import Button from 'components/atoms/Button';
import Image from 'components/atoms/Image';
import { LONG_SEARCH_TIME } from 'data/static';
import { setOutlineIntervalAction } from 'store/actions/mapActions';
import { PortState } from 'store/reducers/portReducer';
import Filter from '../filter/Filter';
import ResultMessage from '../filter/ResultMessage';

interface SearchTabComponentProps {
    defaultData: FilterObjectType;
    active: boolean;
    port: PortType;
    system: SystemType;
    mode: string;
    mapControls: MapControlsInterface;
    openModelFunction: OpenModal;
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    highlightObject: FilterObjectType;
    setSearchObjectAction: SetSearchObjectAction;
    setHighlightObjectAction: SetHighlightObjectAction;
    layout: Layout;
    setSearchControlsAction: SetSearchControlsAction;
    setSwitchAction: SetSwitchAction;
    switchs: SwitchType;
    setOutlineIntervalAction: (outlineInterval: number) => void;
    setLayoutAction: SetLayoutAction;
    favouritControls: FavouritControlsInterface;
    dateTimeFormat: DateTimeFormat;
    profileControls: ProfileControlsInterface;
    mainControls: MainControlsInterface;
    searchId: string;
    searchObject: FilterObjectType;
    showMessageAction: ShowMessageAction;
    portData: PortState;
}

interface SearchTabComponentState {
    active: boolean;
    foundNumbers: SummaryData | null;
    searchNumbers: SummaryData | null;
    initialumbers: SummaryData;
    loading: boolean;
    searching: boolean;
    searchingTime: number;
    initial: boolean;
    searchId: string;
    interfaceVariables: InterfaceVariablesType;
    searchObject: FilterObjectType;
    sourceSearchObject: FilterObjectType;
}

const AFTER_SEARCH_TOOLS = [
    'exportGrid',
    'copyChart',
    'saveFavourit',
    'updateAnalysis',
    'tagsGrid',
    'saveSearch',
    'highlightMenu',
];

const ACTIVE_AFTER_SEARCH_TOOLS = ['inspectTransit'];
const AFTER_FIND_TOOLS = ['updateAnalysis', 'saveSearch', 'saveFavourit'];

class SearchTab extends Component<SearchTabComponentProps, SearchTabComponentState> {
    private countdownInterval: NodeJS.Timeout | null = null;

    constructor(props: SearchTabComponentProps) {
        super(props);
        this.state = {
            loading: false,
            searching: false,
            searchingTime: 0,
            active: props.active,
            interfaceVariables: props.port.meta_data.interfaceVariables,
            searchId: props.searchId,
            initial: true,
            initialumbers: {
                total: props.system.transits.total,
                inDateRangeForReview: props.system.transits.forReview,
                inDateRange: props.system.transits.total,
                forReview: props.system.transits.forReview,
                ppu: props.system.transits.ppu,
                simulated: props.system.transits.simulated,
                endDate: props.system.date.endDate.clone(), //clone from system start date
                startDate: props.system.date.startDate.clone(), //clone from system end date
                time: this.props.dateTimeFormat.parseDateTime(null, 'initialum time'),
            },
            foundNumbers: null,
            searchNumbers: null,
            searchObject: clone(props.searchObject),
            sourceSearchObject: clone(props.searchObject),
        };
    }

    static getDerivedStateFromProps(props: SearchTabComponentProps, state: SearchTabComponentState) {
        if (checkDifferent(props.searchObject, state.searchObject) || props.active !== state.active) {
            return {
                searchObject: clone(props.searchObject),
                active: props.active,
            };
        }

        return null;
    }

    componentDidMount(): void {
        this.props.setSearchControlsAction({
            clear: this.clear,
            search: this.search,
            getSearchObjectNumbers: this.getSearchObjectNumbers,
            getFoundObjectNumbers: this.getFoundObjectNumbers,
            runGetSearchNumbers: this.runGetSearchNumbers,
        });
        // BACK 2.1
        //this.search();
        // REMOVE 2.1
        this.runGetSearchNumbers(true);
    }

    componentDidUpdate(prevProps: SearchTabComponentProps, prevState: SearchTabComponentState) {
        if (prevState.searching !== this.state.searching) {
            if (this.state.searching) {
                // Start countdown
                this.setState({ searchingTime: 60 }, () => {
                    this.countdownInterval = setInterval(() => {
                        this.setState((prevState) => {
                            if (prevState.searchingTime > 0) {
                                return { searchingTime: prevState.searchingTime - 1 };
                            } else {
                                // stop timer when reaches 0
                                if (this.countdownInterval) {
                                    clearInterval(this.countdownInterval);
                                    this.countdownInterval = null;
                                }
                                return null;
                            }
                        });
                    }, 1000);
                });
            } else {
                // Stop countdown
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                this.setState({ searchingTime: 0 }); // optional reset
            }
        }

        if (
            checkDifferent(prevState.searchObject, this.state.searchObject)
            //  && checkDifferent(this.state.searchObject, this.state.sourceSearchObject)
        ) {
            console.log('XHR : Search object updtaed , ready to get numbers ');
            if (this.state.searchObject.uuid) {
                this.runGetSearchNumbers(
                    !checkDifferent(this.state.searchObject, this.state.sourceSearchObject),
                    true,
                    true
                );
            } else {
                this.runGetSearchNumbers(!checkDifferent(this.state.searchObject, this.state.sourceSearchObject));
            }
        }
    }

    componentWillUnmount() {
        // Clean up interval when component unmounts
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }

    getSearchObjectNumbers: GetSearchObjectNumbers = () => {
        return this.state.searchNumbers;
    };
    getFoundObjectNumbers: GetFoundObjectNumbers = () => {
        return this.state.foundNumbers;
    };

    isFoundExecutd = () => {
        return checkDifferent(this.props.searchObject, this.state.sourceSearchObject);
    };

    runGetSearchNumbers = async (initial = false, search = false, highlight = false): Promise<SummaryData | null> => {
        console.log('runGetSearchNumbers');
        this.setState({ loading: true });

        try {
            const res = await searchNumbers(
                'search',
                this.props.port.id,
                formatFilterObject(this.state.searchObject, this.props.port.backEnd?.version, this.props.portData)
            );

            const data = formatSearchNumbers(
                this.props.port.backEnd?.version !== 2 ? res.items : res,
                this.props.port.backEnd?.version
            );

            const foundNumbers = {
                total: data.total,
                inDateRangeForReview: data.dateRangeForReview,
                inDateRange: data.dateRange,
                forReview: data.forReview,
                ppu: data.ppu,
                simulated: data.simulated,
                endDate: this.props.dateTimeFormat.parseDateTime(data.endDate, 'search start date'),
                startDate: this.props.dateTimeFormat.parseDateTime(data.startDate, 'search end date'),
                time: this.props.dateTimeFormat.parseDateTime(null, 'search exceute time'),
            };

            return new Promise((resolve) => {
                this.setState(
                    {
                        initial: initial,
                        loading: false,
                        foundNumbers,
                    },
                    () => {
                        if (search) {
                            this.search(highlight);
                        }
                        if (this.isFoundExecutd()) {
                            this.props.setLayoutAction([
                                {
                                    action: 'DEFAULT',
                                    data: {
                                        searchId: getId(),
                                        searching: false,
                                        searchingTime: 0,
                                    },
                                },
                                {
                                    action: 'UPDATE_TOOLS',
                                    data: {
                                        section: 'grid',
                                        names: AFTER_FIND_TOOLS,
                                        active: true,
                                        keepMenu: true,
                                    },
                                },
                                {
                                    action: 'UPDATE_TOOLS',
                                    data: {
                                        section: 'profile',
                                        names: AFTER_FIND_TOOLS,
                                        active: true,
                                        keepMenu: true,
                                    },
                                },
                                {
                                    action: 'UPDATE_TOOLS',
                                    data: {
                                        section: 'chart',
                                        names: AFTER_FIND_TOOLS,
                                        active: true,
                                        keepMenu: true,
                                    },
                                },
                            ]);
                        }

                        resolve(foundNumbers);
                    }
                );
            });
        } catch (error) {
            this.props.setErrorHandlerAction(error);
            this.setState({ loading: false });
            return null;
        }
    };

    saveAs = () => {
        this.props.openModelFunction(
            'saveSearchModel',
            0,
            'medium',
            {
                searchObject: this.state.searchObject,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction('saveSearchModel');
                },
            }
        );
    };

    search: SearchInterface = (highlight = false) => {
        if (
            (this.state.searchObject.limit === 0 &&
                this.state.foundNumbers === null &&
                this.state.initialumbers.total > this.state.interfaceVariables?.maxSearchLimit_transits) ||
            (this.state.searchObject.limit === 0 &&
                this.state.foundNumbers !== null &&
                this.state.foundNumbers.total > this.state.interfaceVariables?.maxSearchLimit_transits)
        ) {
            this.props.openModelFunction(
                'searchLimit',
                0,
                'medium',
                {
                    maxTransits: this.state.interfaceVariables?.maxSearchLimit_transits,
                },
                {
                    onCancel: () => {
                        this.props.openModelFunction('searchLimit');
                    },
                }
            );
            return;
        }
        if (this.props.mode === 'search') {
            this.setState({
                searching: true,
                searchingTime: 60,
            });
            //  this.props.setSystemLoadingAction(true);
        }

        this.props.setLayoutAction([
            {
                action: 'DEFAULT',
                data: {
                    searching: true,
                    searchingTime: 60,
                },
            },
        ]);

        searchData(
            'search',
            this.props.port.id,
            formatFilterObject(this.state.searchObject, this.props.port.backEnd?.version, this.props.portData)
        )
            .then(async (res) => {
                // eslint-disable-next-line prefer-const
                let { transits, transitsData } = await formatTransits(
                    this.props.dateTimeFormat,
                    res,
                    this.props.switchs,
                    this.props.portData,
                    this.props.port.backEnd?.version || 1
                );

                this.props.setSwitchAction('heatmap', { loading: false, value: false });

                const loadChart = this.props.mainControls.getLoadSavedData(true);
                if (loadChart) {
                    transits = replaceOptions(transits, loadChart.data.transits);
                }
                await this.props.mainControls.setTransits(transits, transitsData, getId());
                this.props.mapControls?.chart?.setClickMatrix([]);
                if (this.props.mode === 'search') {
                    this.setState({
                        searching: false,
                        searchingTime: 0,
                    });
                    // this.props.setSystemLoadingAction(false);
                }
                const lodedFilter = this.props.favouritControls.getLodedFilter();
                if (
                    !highlight ||
                    !checkDifferent(
                        //@ts-ignore
                        { ...this.state.searchObject, status: lodedFilter?.highlight?.status },
                        lodedFilter?.highlight
                    )
                ) {
                    this.props.setHighlightObjectAction(clone(this.state.searchObject));
                } else {
                    if (lodedFilter) {
                        this.props.setHighlightObjectAction(
                            formatSavedFilter(this.props.dateTimeFormat, lodedFilter.highlight)
                        );
                    }

                    if (loadChart) {
                        this.props.setOutlineIntervalAction(loadChart.data.outlineInterval);

                        if (loadChart.highlight) {
                            this.props.setHighlightObjectAction(
                                formatSavedFilter(this.props.dateTimeFormat, loadChart.data.highlightObject)
                            );
                        } else {
                            this.props.setHighlightObjectAction(clone(this.state.searchObject));
                        }

                        if (loadChart.data.inspectTransit) {
                            //TODO find a way to solve setTimeout
                            setTimeout(() => {
                                this.props.mapControls.chart?.setClickMatrix(loadChart.data.clickMatrix);
                                this.props.mainControls.inspectTransit(
                                    loadChart.data.inspectTransit,
                                    this.props.dateTimeFormat.parseDateTime(loadChart.data.inspectSelectedTime.date)
                                );
                                this.props.mapControls.chart?.setTooltips(loadChart.data.tooltips);
                            }, 500);
                        }
                    }
                }

                this.props.setLayoutAction([
                    {
                        action: 'DEFAULT',
                        data: {
                            searchId: getId(),
                            searching: false,
                            searchingTime: 0,
                            inspectId: getId(),
                            inspectTransit: null,
                        },
                    },

                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'grid',
                            names: AFTER_SEARCH_TOOLS,
                            active: true,
                            state: false,
                        },
                    },
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'profile',
                            names: AFTER_SEARCH_TOOLS,
                            active: true,
                            state: false,
                        },
                    },
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'chart',
                            names: AFTER_SEARCH_TOOLS,
                            active: true,
                            state: false,
                        },
                    },
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'grid',
                            names: ACTIVE_AFTER_SEARCH_TOOLS,
                            active: true,
                            state: true,
                        },
                    },
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'profile',
                            names: ACTIVE_AFTER_SEARCH_TOOLS,
                            active: true,
                            state: true,
                        },
                    },
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'chart',
                            names: ACTIVE_AFTER_SEARCH_TOOLS,
                            active: true,
                            state: true,
                        },
                    },

                    // {
                    //     action: 'UPDATE_MENU',
                    //     data: {
                    //         name: 'searchMenu',
                    //         section: 'chart',
                    //         state: true,
                    //     },
                    // },
                    {
                        action: 'UPDATE_MENU',
                        data: {
                            name: 'searchMenu',
                            section: 'profile',
                            state: true,
                        },
                    },
                    // {
                    //     action: 'UPDATE_MENU',
                    //     data: {
                    //         name: 'searchMenu',
                    //         section: 'grid',
                    //         state: true,
                    //     },
                    // },
                    {
                        action: 'UPDATE_MENU',
                        data: {
                            name: 'inspectTransitMenu',
                            section: 'chart',
                            state: true,
                            active: true,
                            display: true,
                        },
                    },
                    {
                        action: 'UPDATE_MENU',
                        data: {
                            name: 'inspectTransitMenu',
                            section: 'grid',
                            state: true,
                            active: true,
                            display: true,
                        },
                    },
                ]);

                const data = formatSearchNumbers(
                    res,
                    this.props.port.backEnd?.version
                );

                this.setState({
                    searchNumbers: {
                        total: data.total,
                        inDateRangeForReview: data.dateRangeForReview,
                        inDateRange: data.dateRange,
                        forReview: data.forReview,
                        ppu: data.ppu,
                        simulated: data.simulated,
                        endDate: this.props.dateTimeFormat.parseDateTime(data.endDate, 'search start date'),
                        startDate: this.props.dateTimeFormat.parseDateTime(data.startDate, 'search end date'),
                        time: this.props.dateTimeFormat.parseDateTime(null, 'search exceute time'),
                    },
                });
            })
            .catch((error) => {
                console.log(error);
                if (!error.response || error?.response?.status === 504) {
                    this.setState({
                        searching: false,
                        searchingTime: 0,
                    });
                    this.props.showMessageAction({
                        messageType: 'ERROR',
                        message: translate('your search couldnt be completed'),
                        options: {
                            autoClose: false,
                            hideProgressBar: true,
                        },
                    });
                } else {
                    this.props.setErrorHandlerAction(error);
                }
            });
    };

    cancelSearch = () => {
        if (searchCancel) {
            searchCancel();
        }
        this.setState({
            searching: false,
            searchingTime: 0,
        });
    };

    clear: ClearInterface = () => {
        this.setState({ initial: true, foundNumbers: null, searchNumbers: null, loading: true }, async () => {
            this.props.setSearchObjectAction(clone(this.state.sourceSearchObject));
            await this.props.mainControls.setTransits([], {}, getId());
            this.props.mapControls.chart?.createMarkingLayer([], true, false);
            this.props.favouritControls.clearLodedFilter();
            this.props.profileControls.clearProfileData();
            this.props.setLayoutAction([
                {
                    action: 'DEFAULT',
                    data: {
                        searchId: getId(),
                    },
                },
                {
                    action: 'UPDATE_TOOLS',
                    data: {
                        section: 'grid',
                        names: AFTER_SEARCH_TOOLS,
                        active: false,
                        keepMenu: true,
                    },
                },
                {
                    action: 'UPDATE_TOOLS',
                    data: {
                        section: 'chart',
                        names: AFTER_SEARCH_TOOLS,
                        active: false,
                        keepMenu: true,
                    },
                },
                {
                    action: 'UPDATE_TOOLS',
                    data: {
                        section: 'profile',
                        names: AFTER_SEARCH_TOOLS,
                        active: false,
                        keepMenu: true,
                    },
                },
            ]);
        });
    };

    handleChange = (value: number) => {
        const filterObject = this.state.searchObject;

        const updatedFilterObject = { ...filterObject, limit: value };

        this.props.setSearchObjectAction(updatedFilterObject);
    };

    render() {
        return (
            <div className={twclsx(!this.state.active && 'hidden')}>
                {this.state.searching ? (
                    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                        <div className="text-center">
                            <div className="flex items-center justify-center">
                                <Image alt="loading" className="mx-2 w-5" src="/static/images/loading.svg" />
                                {this.state.searchingTime < LONG_SEARCH_TIME
                                    ? translate('This is taking longer than usual.')
                                    : translate('Loading search data...')}
                            </div>
                            <div onClick={this.cancelSearch} className="mt-2 text-primary-link cursor-pointer">
                                {translate('cancel this search')}
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <ResultMessage
                            display="search"
                            limit={this.state.searchObject.limit}
                            isLoading={this.state.loading}
                            isFoundResults={this.state.foundNumbers !== null}
                            isSearchResults={this.state.searchNumbers !== null}
                            foundNumbers={this.state.foundNumbers}
                            initialumbers={this.state.initialumbers}
                            searchNumbers={this.state.searchNumbers}
                        >
                            <div className="  w-full mt-4 justify-end  flex gap-2">
                                <Button
                                    onClick={this.search}
                                    type="button"
                                    disabled={this.state.initial || this.state.loading}
                                    className={twclsx(
                                        'px-4',
                                        'h-5',
                                        'w-16',
                                        this.state.loading ? 'bg-gray-300 ' : 'bg-primary-submit ',
                                        'rounded-md',
                                        'px-3',
                                        'rounded',
                                        'text-white'
                                    )}
                                >
                                    {translate('load')}
                                </Button>

                                <Button
                                    onClick={this.clear}
                                    type="button"
                                    disabled={this.state.initial}
                                    className="px-4 py-2 h-5 w-16 bg-primary-submit rounded-md text-white"
                                >
                                    {translate('clear')}
                                </Button>
                            </div>
                        </ResultMessage>

                        <Scrollbars
                            className={twclsx('h-search', 'w-full', 'pr-1', 'mt-2')}
                            renderThumbVertical={({ style, ...props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...style,
                                        background: '#0000004a',
                                        borderRadius: 5,
                                        zIndex: 30, // Custom z-index
                                        position: 'relative', // Required for z-index to work
                                    }}
                                />
                            )}
                            style={{ height: 'auto', zIndex: 10 }}
                        >
                            <Filter
                                defaultData={this.props.defaultData}
                                type="search"
                                autoApply={true}
                                seFilterObject={this.props.setSearchObjectAction}
                                filterObject={this.state.searchObject}
                            ></Filter>
                        </Scrollbars>

                        <div className="fixed w-72 h-10 pt-1 justify-evenly mx-2 bottom-2 flex gap-2"></div>
                    </>
                )}
            </div>
        );
    }
}

const searchTabStateToProps = (state: RootState) => ({
    port: state.port.port,
    portData: state.port,
    system: state.port.system,
    mode: state.layout.mode,
    mainControls: state.layout.mainControls,
    highlightObject: state.layout.highlightObject,
    mapControls: state.map.mapControls,
    profileControls: state.layout.profileControls,
    defaultData: state.port.defaultData,
    openModelFunction: state.layout.openModelFunction,
    switchs: state.layout.switchs,
    favouritControls: state.layout.favouritControls,
    dateTimeFormat: state.port.dateTimeFormat,
    layout: state.layout.layout,
});

const searchTabDispatchToProps = (dispatch: Dispatch) => ({
    setSwitchAction: bindActionCreators(setSwitchAction, dispatch),
    setSearchObjectAction: bindActionCreators(setSearchObjectAction, dispatch),
    setHighlightObjectAction: bindActionCreators(setHighlightObjectAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setSearchControlsAction: bindActionCreators(setSearchControlsAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
    setOutlineIntervalAction: bindActionCreators(setOutlineIntervalAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
});
export default connect(searchTabStateToProps, searchTabDispatchToProps)(SearchTab);
